import React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
//
import { SimpleTable } from "@components/simple-table";

export const Route = createFileRoute("/_authenticated/app/players/$playerId/")({
  component: PlayerDetailPage,
});

function PlayerDetailPage(): React.ReactElement {
  const { t } = useTranslation();
  const player = Route.parentRoute.useLoaderData();
  return (
    <SimpleTable
      data={player}
      title={t("playerDetailPage.tableTitle", { playerId: player.id })}
    />
  );
}
